import { HandHeart, MessageCircle, Coins, Home } from "lucide-react";

const REASONS = [
  {
    icon: HandHeart,
    title: "Patient & friendly",
    desc: "I take the time to explain things in plain English. No eye-rolling, ever.",
  },
  {
    icon: Coins,
    title: "Fair pricing",
    desc: "$1 a minute means a 15-minute fix is just $15. No surprise bills.",
  },
  {
    icon: Home,
    title: "I come to you",
    desc: "On-site visits across Perth's north-western suburbs — no lugging gear anywhere.",
  },
  {
    icon: MessageCircle,
    title: "Local & contactable",
    desc: "Just one phone number, one real person. Call or text — I'll get back to you.",
  },
];

export default function WhyDazTec() {
  return (
    <section
      data-testid="why-daztec-section"
      className="py-20 sm:py-24 bg-white border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <p className="text-sm uppercase tracking-[0.18em] font-semibold text-[#D97706]">
              Why DazTec
            </p>
            <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
              The kind of tech help you'd want for your own mum.
            </h2>
            <p className="mt-5 text-lg text-slate-700 leading-relaxed">
              No call centres. No upsells. Just a local person who's good with
              tech and even better with people. If I can't fix it, I'll tell you
              straight — and you don't pay a cent.
            </p>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            {REASONS.map((r) => {
              const Icon = r.icon;
              return (
                <div
                  key={r.title}
                  className="bg-[#FDFBF7] border border-slate-200 rounded-2xl p-6"
                  data-testid={`why-card-${r.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                >
                  <div className="w-12 h-12 rounded-xl bg-[#D97706]/12 text-[#D97706] flex items-center justify-center">
                    <Icon className="w-6 h-6" strokeWidth={2} />
                  </div>
                  <h3 className="mt-4 text-lg font-semibold text-slate-900 font-[Outfit]">
                    {r.title}
                  </h3>
                  <p className="mt-2 text-base text-slate-700">{r.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
